<template>
  <!-- popup (s) -->
  <div class="popWrap">
    <div class="popup">
      <div class="popContain">
        <div class="popCont full">
          <div class="popHead">
            <h1 class="titH1">
              포토리뷰
              <i>{{ photoIdx + 1 }}</i>
              <span class="pointC6">
                /
                <i>{{ reviewSummary.photoReviewCount }}</i>
              </span>
            </h1>
          </div>
          <div class="popBody">
            <div class="popInner">
              <!-- 본문 (s) -->
              <section class="full mt0">
                <div class="slide fraction" id="pop_slide1">
                  <ul class="slideList">
                    <!--<li v-for="url in reviewPhotoList[currentReviewPhotoIdx].photoPath.urls">-->
                    <template v-for="reviewPhoto in reviewPhotoList">
                      <li v-for="url in reviewPhoto.photoPath.urls" :key="url" style="height: 300px">
                        <a href="javascript:void(0);">
                          <span class="img">
                            <img :src="url" alt="" style="height: 100%" />
                            <!-- <img src="@/../static/img/mw/temp/temp_product_detail01.png" alt="" /> -->
                          </span>
                        </a>
                      </li>
                    </template>
                  </ul>
                </div>
                <div class="reviewList">
                  <div class="topArea">
                    <div class="ratingWrap">
                      <span class="starRating">
                        <span :style="{ width: reviewPhotoList[photoIdx].averageScore * 20 + '%' }"></span>
                      </span>
                      <span class="user">{{ reviewPhotoList[photoIdx].writer }}</span>
                    </div>
                    <span class="date">{{ reviewPhotoList[photoIdx].createDate }}</span>
                  </div>
                  <p class="cont">{{ reviewPhotoList[photoIdx].contents }}</p>
                </div>
              </section>
              <!-- 본문 (e) -->
            </div>
          </div>

          <button type="button" class="btnIco_close" @click="$emit('close')"><span>팝업 닫기</span></button>
        </div>
      </div>
    </div>
  </div>
  <!-- popup (e) -->
</template>

<script>
import * as customjs from '@/../static/js/m.front.js';
export default {
  name: 'ReviewPhotoPop',
  props: ['reviewSummary', 'reviewPhotoList', 'reviewPhotoLengthList', 'currentReviewPhotoIdx'],
  data() {
    return {
      photoIdx: this.currentReviewPhotoIdx, // 화면에 보이는 인덱스
    };
  },
  mounted() {
    this.currentReviewPhotoNum = this.currentReviewPhotoIdx + 1;
    this.reviewPhotoContents = this.reviewPhotoList[this.currentReviewPhotoIdx].contents;
    let startIndex = 0;
    if (this.currentReviewPhotoIdx > 0) {
      for (let i = 0; i < this.currentReviewPhotoIdx; i++) {
        startIndex = startIndex + this.reviewPhotoLengthList[i];
      }
    }

    const thisPage = this; // 슬라이더 변수 접근용
    setTimeout(function () {
      let swiper = customjs.slideInit2('#pop_slide1', 5000, false, 300, false, 1, 0, 'fraction', startIndex);
      swiper.on('slideChange', function () {
        let lengthSum = 0;
        for (let j = 0; j < thisPage.reviewPhotoLengthList.length; j++) {
          lengthSum = lengthSum + thisPage.reviewPhotoLengthList[j];
          if (swiper.activeIndex + 1 <= lengthSum) {
            thisPage.photoIdx = j;
            break;
          } else {
            continue;
          }
        }
      });
    }, 100);
  },
};
</script>
